// Auto chapter numbering.
// A title that is exactly "Chapter N" is treated as an AUTO chapter and gets
// renumbered by its position. Any other title (e.g. "Prologue", "The Battle")
// is a CUSTOM name — shown as-is and NOT counted in the numbering.
export const AUTO_CHAPTER_RE = /^\s*chapter\s+\d+\s*$/i;

export function numberedTitles(chapters = []) {
  const map = {};
  let n = 0;
  for (const c of chapters) {
    const t = (c.title || "").trim();
    if (AUTO_CHAPTER_RE.test(t)) {
      n += 1;
      map[c.id] = `Chapter ${n}`;
    } else {
      map[c.id] = t || "Untitled";
    }
  }
  return map;
}
